(function(){
  if (window.__dafnasMotion) return;
  window.__dafnasMotion = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css = ''
    + '.df-img img,.df-img video,.dpdp__media img,.dpdp__media video,.df-reel video{opacity:0;transform:scale(1.07);transition:opacity 1.2s ease,transform 2.2s cubic-bezier(.22,.61,.36,1)}'
    + '.df-in.df-img img,.df-in.df-img video,.df-in img,.df-in video{opacity:1;transform:scale(1)}'
    + '.df-rv{opacity:0;transform:translateY(16px);transition:opacity .9s ease,transform .9s cubic-bezier(.22,.61,.36,1)}'
    + '.df-rv.df-in{opacity:1;transform:none}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var mediaSel = '.df-img, .dpdp__media figure, .df-reel';
  var textSel = '.df-h, .df-eyebrow, .df-dl, .df-ing, .df-row, .df-quote, .df-col, .df-note, .df-steps4 li, .df-rows li, .df-acc, .dpdp__buy > *';

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      e.target.classList.add('df-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  function init(){
    document.querySelectorAll(mediaSel).forEach(function(el){ io.observe(el); });
    document.querySelectorAll(textSel).forEach(function(el, i){
      el.classList.add('df-rv');
      el.style.transitionDelay = ((i % 4) * 90) + 'ms';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
